import { Component, OnInit, OnDestroy, ElementRef, ViewChild, EventEmitter, Output, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DownloadQrComponent } from 'src/app/modal/download-qr/download-qr.component';
import { plantsList } from 'src/app/shared/interfaces/interfaces';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Subscription, generate } from 'rxjs';
import { PlantService } from 'src/app/services/plant.service';
import { filter, pairwise } from 'rxjs/operators';
import { Observable, Observer } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import * as JSZip from 'jszip';
import * as JSZipUtils from '../../../assets/script/jszip-utils.js';
import html2pdf from 'html2pdf.js';
import { GeneratePdfComponent } from 'src/app/_Shared/_Components/_Generic/generate-pdf/generate-pdf.component';
import { RolebasedactionService } from 'src/app/services/rolebasedaction.service';

@Component({
  standalone: false,
  selector: 'app-list-of-plants-trees',
  templateUrl: './list-of-plants-trees.component.html',
  styleUrls: ['./list-of-plants-trees.component.scss'],
})
export class ListOfPlantsTreesComponent implements OnInit, OnDestroy {

  @ViewChild('allQrCodeAll', { static: false }) allQrCodeAll: ElementRef;

  // plants: plantsList[] = [];
  plants: any[] = [];
  newPlants: any[] = [];
  masterSelectedPlants: boolean;
  checkedPlantsList: any;
  checkedPlantsListOnlyQr: any;
  page: any;
  totalPages = 1;
  indexPage = 1;
  pageNo: number = 0;
  pageSize: number = 20;
  totalRows: number = 0;
  searchText: string = '';
  downloadtype: string = '';
  vegitationModel: any;
  private subscriptions = new Subscription();
  parkId: any;
  base64Image: any;
  showDropdown: boolean = false;
  pdfElementContent: any;
  public imageofQrCode: any;
  setdynamicimage: any;
  foodvendorView: any;

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private sideNavService: SidenavService,
    private appStateSrv: AppStateProvider,
    private plantService: PlantService,
    private http: HttpClient,
    private rolebasedactionService: RolebasedactionService,
  ) {
    this.masterSelectedPlants = false;

    localStorage.setItem('expandNavLand', 'true');
    const route = this.sideNavService.routingChunks({
      name: 'Landscaping and Vegetation',
      subNav: '1',
      subNavLink: '',
      //subNavLink: '/landscaping-and-vegetation/list-of-plants-trees',
    });
    this.appStateSrv.setSideNavState(route);
  }

  ngOnInit(): void {
    this.foodvendorView = this.rolebasedactionService.checkUserRolePermissionExits('Managed Services:View');
    this.pdfElementContent = localStorage.getItem('allQrCodeAll');
    this.totalRows = 0;
    this.pageNo = 0;
    this.pageSize = 20;
    this.page = 0;
    this.indexPage = 1;
    this.imageofQrCode = '';

    this.getVegitationPlantList();
  }

  paginationCount(val: number) {
    return val % 10 == 0 ? Math.floor(val / 10) : Math.floor(val / 10) + 1;
  }

  ngOnDestroy() {
    localStorage.removeItem('expandNavLand');
    this.subscriptions.unsubscribe();
  }

  checkUncheckAll() {
    for (var i = 0; i < this.plants.length; i++) {
      this.plants[i].isSelected = this.masterSelectedPlants;
    }
    this.getCheckedItemList();
    console.log(this.masterSelectedPlants);
    if (this.masterSelectedPlants === false) {
      this.showDropdown = false;
    }
  }

  // Check All Checkbox Checked
  isAllSelected() {
    this.showDropdown = false;
    this.masterSelectedPlants = this.plants.every(function (item: any) {
      return item.isSelected === true;
    });
    this.getCheckedItemList();
  }

  // Get List of Checked Items
  getCheckedItemList() {

    this.checkedPlantsList = [];
    this.checkedPlantsListOnlyQr = [];

    for (var i = 0; i < this.plants?.length; i++) {

      if (this.plants[i].isSelected) {

        this.checkedPlantsList.push(this.plants[i]);

        if (this.plants[i].qrCodePath != null) {
          this.checkedPlantsListOnlyQr.push({
            qrCodePath: this.plants[i].qrCodePath,
            vegetationName: this.plants[i].vegetationName,
            species: this.plants[i].species,
            parkName: this.plants[i].parkName,
          });
        }
        this.showDropdown = true;
      }
    }
    this.checkedPlantsListOnlyQr.forEach((element: any, index: string | number) => {
      this.convertImageToBase64(this.checkedPlantsListOnlyQr[index]['qrCodePath'], (dataURL: any) => {
        this.checkedPlantsListOnlyQr[index]['qrCodePath'] = dataURL;
      });
    });

    this.plantService.sendData(this.checkedPlantsListOnlyQr);

    console.log(this.checkedPlantsListOnlyQr);

    this.checkedPlantsList = JSON.stringify(this.checkedPlantsList);
    // console.log(this.checkedPlantsList);
  }

  openModal(qrLink: string, vegitationName: string, vegetationId: string, species: string, plantName: string): void {

    const modalOptions: NgbModalOptions = {
      size: 'md',
    };

    const modalRef = this.modalService.open(GeneratePdfComponent, modalOptions);
    // You can pass data to the modal using the `componentInstance` property
    modalRef.componentInstance.link = qrLink ? qrLink : '';
    modalRef.componentInstance.vegname = vegitationName;
    modalRef.componentInstance.vegetationId = vegetationId;
    modalRef.componentInstance.species = species;
    modalRef.componentInstance.displayParkName = plantName; // add park name
  }

  goToPlantDetails(id: number): void {
    this.router.navigate(['/plant-details/' + id]);
  }

  searchByText(event: any) {
    if (!event || event === '') {
      // Reset to original list
      this.newPlants = this.plants;
      this.totalRows = this.plants?.length || 0;
      return;
    }

    // Filter based on search text
    const searchLower = event.toLowerCase();
    this.newPlants = this.plants.filter((item: { vegetationName: any }) => {
      if (!item || !item.vegetationName) return false;
      return item.vegetationName.toLowerCase().includes(searchLower);
    });
    this.totalRows = this.newPlants?.length || 0;
  }

  downloadQrCodeAsPdf(qrLink: string, vegitationName: string) {
    const pdfOptions = {
      margin: 1,
      filename: `${vegitationName}_QR_Code.pdf`,
      image: { type: 'jpeg' as const, quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true, allowTaint: false },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' as const },
    };

    const content = document.createElement('div');
    const qrCodeImg = new Image();
    qrCodeImg.crossOrigin = 'anonymous';

    qrCodeImg.onload = () => {
      content.appendChild(qrCodeImg);
      html2pdf()
        .from(content)
        .set(pdfOptions)
        .outputPdf()
        .then((pdf) => {
          const blob = new Blob([pdf], { type: 'application/pdf' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `${vegitationName}_QR_Code.pdf`;
          link.click();
        });
    };

    qrCodeImg.onerror = () => console.error('QR code image failed to load:', qrLink);
    qrCodeImg.src = qrLink ? qrLink : '';
  }

  // Function to download all QR Codes as PDFs in a Zip file
  /* downloadAllQrCodesAsPdfZip() {
    const zip = new JSZip();

    for (const plant of this.checkedPlantsListOnlyQr) {
      const pdfOptions = {
        margin: 10,
        filename: `${plant.qrcodename}_QR_Code.pdf`,
        image: { type: 'png' },
        html2canvas: {},
      };

      // const content = document.createElement('div');
      // const qrCodeImg = new Image();
      // qrCodeImg.src = plant.qrcodepath ? plant.qrcodepath : '';
      // content.appendChild(qrCodeImg);

      html2pdf().from(this.pdfElementContent).set(pdfOptions).save().then((pdf) => {

        const pdfBlob = new Blob([pdf], { type: 'application/pdf' });
        zip.file(`${plant.qrcodename}_QR_Code.pdf`, pdfBlob);
      });
    }

    zip.generateAsync({ type: 'blob' }).then((content) => {
      const url = URL.createObjectURL(content);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'QR_Codes.zip';
      link.click();
    });
  } */

  convertImageToBase64(imgUrl: string, callback: { (dataURL: any): void; (arg0: string): any }) {
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.height = image.naturalHeight;
      canvas.width = image.naturalWidth;
      ctx.drawImage(image, 0, 0);
      const dataUrl = canvas.toDataURL();
      callback && callback(dataUrl);
      // this.previousImageConvertFile.push({ 'dataUrl': dataUrl, 'imgUrl': imgUrl });
      let filename = imgUrl.substring(imgUrl.lastIndexOf('/') + 1); //imgUrl.lastIndexOf("/") + 1;
    };
    image.src = imgUrl;
  }


  generatePdf() {

    var element = document.getElementById('allQrCodeAllBulkDownload');

    if (element) {
      const elementHtml = element.outerHTML;
      localStorage.setItem('pdfElement', elementHtml);

      // Generate the PDF as you were doing before
      var opt = {
        margin: 1,
        filename: 'All_QR_Code.pdf',
        image: { type: 'jpeg' as const, quality: 0.98 },
        html2canvas: { scale: 2 },
        enableLinks: true,
        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' as const },
      };
      html2pdf().from(element).set(opt).save();
    } else {
      console.error('PDF element not found.');
    }
  }

  downloadAllQrCodesAsPdfZip() {

    this.generatePdf();

    // for (let i = 0; i <= this.checkedPlantsListOnlyQr.length - 1; i++) {
    //   this.convertImageToBase64(this.checkedPlantsListOnlyQr[i].qrCodePath, (dataURL: any) => {
    //     this.imageofQrCode = dataURL;
    //     if (this.imageofQrCode !== '') {
    //       console.log(this.imageofQrCode);
    //       this.generatePdf();
    //     }
    //   });
    // }


    // const zip = new JSZip();
    // var element = document.getElementById('allQrCodeAll');

    // const pdfOptions = {
    //   margin: 1,
    //   filename: `All_QR_Code.pdf`,
    //   image: { type: 'jpg', quality: 0.98 },
    //   html2canvas: { scale: 2 },
    //   jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
    // };

    // let filesToZip = this.checkedPlantsListOnlyQr.length;
    // let completedFiles = 0;

    // for (const plant of this.checkedPlantsListOnlyQr) {
    //   html2pdf()
    //     .from(element)
    //     .set(pdfOptions)
    //     .outputPdf()
    //     .then((pdf) => {
    //       const pdfBlob = new Blob([pdf], { type: 'application/pdf' });
    //       zip.file(`${plant.vegetationName}_QR_Code.pdf`, pdfBlob);

    //       completedFiles++;

    //       if (completedFiles === filesToZip) {
    //         zip.generateAsync({ type: 'blob' }).then((content) => {
    //           const url = URL.createObjectURL(content);
    //           const link = document.createElement('a');
    //           link.href = url;
    //           link.download = 'QR_Codes.zip';
    //           link.click();
    //         });
    //       }
    //     });
    // }
  }

  downloadAllQrCode(event: any) {
    // this.vegitationModel = {};
    // this.vegitationModel['type'] = 'vegitation';

    // this.plantService
    //   .downloadAllQrCode(this.vegitationModel)
    //   .subscribe((res) => {
    //     console.log(res);
    //   });
    console.log(this.checkedPlantsListOnlyQr);

    let count = 0;
    var zip = new JSZip();
    this.checkedPlantsListOnlyQr.forEach((url: string) => {
      console.log(url['qrcodepath']);
      console.log(url['qrcodename']);

      const filename = url['qrcodename']; // url.split('/')[url.split('/').length - 1];

      JSZipUtils.getBinaryContent(url['qrcodepath'], (err: any, data: any) => {
        zip.file(filename + '.png', data, { base64: true });
        count++;
        if (count === this.checkedPlantsListOnlyQr.length) {
          zip.generateAsync({ type: 'blob' }).then(function (content) {
            const objectUrl: string = URL.createObjectURL(content);
            const link: any = document.createElement('a');
            link.download = 'qr-code-images.zip';
            link.href = objectUrl;
            link.click();
          });
        }
      });
    });

    // for (var i = 0; i < this.checkedPlantsListOnlyQr?.length; i++) {

    //   let imageUrl = this.checkedPlantsListOnlyQr[i].qrcodepath;
    //   let imagename = this.checkedPlantsListOnlyQr[i].qrcodename + ".png";

    //   this.getBase64ImageFromURL(imageUrl).subscribe((base64data: string) => {
    //     console.log(base64data);
    //     this.base64Image = "data:image/png;base64," + base64data;
    //     // save image to disk
    //     var link = document.createElement("a");

    //     document.body.appendChild(link); // for Firefox

    //     link.setAttribute("href", this.base64Image);
    //     link.setAttribute("download", imagename);
    //     link.click();
    //   });
    // }
  }

  handelVegitationPlantList(event: any) {
    console.log(event);
    this.page = event;
    this.indexPage = this.page;
    // this.getVegitationPlantList();
  }

  getVegitationPlantList() {
    const vegitationPagination = {
      start: (this.page - 1) * this.pageSize, //this.page,
      offset: this.pageSize,
      parkID: this.parkId,
    };

    console.log(vegitationPagination);

    this.parkId = localStorage.getItem('parkId');
    console.log(this.parkId);

    this.plantService.getVegitationPlantList(this.parkId).subscribe((res) => {
      if (res?.isValid === true) {
        this.plants = res?.list;
        this.newPlants = res?.list;
        this.totalRows = res?.list.length;
      } else {
        this.plants = [];
        this.newPlants = [];
        this.totalRows = 0;
      }
    });

    for (var i = 0; i < this.plants?.length; i++) {
      this.plants[i].isSelected = false;
    }

    // this.plants.push({ "isSelected": false });
    console.log(this.plants);
    this.getCheckedItemList();
  }

  getBase64ImageFromURL(url: string) {
    return Observable?.create((observer: Observer<string>) => {
      const img: HTMLImageElement = new Image();
      img.crossOrigin = 'Anonymous';
      img.src = url;
      if (!img.complete) {
        img.onload = () => {
          observer.next(this.getBase64Image(img));
          observer.complete();
        };
        img.onerror = (err) => {
          observer.error(err);
        };
      } else {
        observer.next(this.getBase64Image(img));
        observer.complete();
      }
    });
  }

  getBase64Image(img: HTMLImageElement) {
    const canvas: HTMLCanvasElement = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx: CanvasRenderingContext2D = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);
    const dataURL: string = canvas.toDataURL('image/png');

    return dataURL.replace(/^data:image\/(png|jpg);base64,/, '');
  }
}
